module.exports = __webpack_public_path__ + "img/ok@2x.0930512b.png";